import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {CategoryState} from "./CategoryState";
import {
	CATEGORIES_FETCHED,
	CATEGORY_CREATED,
	CATEGORY_SORT_ORDER_UPDATED,
	CATEGORY_UPDATED
} from "../../action/category/actionType";

/**
 * Initial state for categories.
 */
const initState: CategoryState = {
	categories: none
};

const reducer = handleActions({
	[CATEGORIES_FETCHED]: (state: CategoryState, action: Action<any>): CategoryState => {
		return {...state, categories: option(action.payload.categories)};
	},
	[CATEGORY_CREATED]: (state: CategoryState, action: Action<CATEGORY_CREATED>): CategoryState => {
		return {...state, categories: option(state.categories.getOrElse([]).concat(action.payload.category))};
	},
	[CATEGORY_UPDATED]: (state: CategoryState, action: Action<CATEGORY_UPDATED>): CategoryState => {
		const categories = state.categories.getOrElse([]).map(category => {
			if (category.id == action.payload.category.id) {
				return action.payload.category;
			}
			else {
				return category;
			}
		});
		return {...state, categories: option(categories)};
	},
	[CATEGORY_SORT_ORDER_UPDATED]: (state: CategoryState, action: Action<CATEGORY_SORT_ORDER_UPDATED>): CategoryState => {
		return {...state, categories: option(action.payload.categories)};
	},
}, initState);

export default reducer;